<template>
  <div
    class="abr-splash"
    :class="{ 'abr-splash--hide': !show }"
    :style="{ '--abr-splash-delay': delay }"
    aria-hidden="true"
  >
    <svg v-if="isAbriron" class="abr-splash__logo" :viewBox="viewBox">
      <path class="abr-splash__fill" :d="path" />
      <path class="abr-splash__line" pathLength="1" :d="path" />
    </svg>
    <img v-else class="abr-splash__img" :src="logo" alt="">
    <div class="abr-splash__bar"><i /></div>
    <span class="abr-splash__ver">{{ versionText }}</span>
  </div>
</template>

<script>
// Dashboard loading overlay. Same markup/classes as the pre-Vue splash in
// public/index.html (styles live in public/splash.css), so when Vue takes
// over the screen does not change. The animation is offset by the time
// since page load so it continues instead of restarting.
import { LOGO_PATH, LOGO_VIEWBOX } from './logoPath'

export default {
  name: 'AppSplash',
  props: {
    show: { type: Boolean, default: true },
    // other brands: their own logo image (abriron uses the animated SVG)
    logo: { type: String, default: null },
  },
  data () {
    return {
      path: LOGO_PATH,
      viewBox: LOGO_VIEWBOX,
      delay: '-' + (performance.now() % 3200 / 1000).toFixed(2) + 's',
    }
  },
  computed: {
    isAbriron () {
      return this.$brand === 'abriron'
    },
    // Same text as public/index.html builds from the host name.
    versionText () {
      const v = window.version || ''
      const parts = window.location.hostname.split('.')
      const host = parts.length > 1 ? parts[parts.length - 2] : parts[0]
      const name = host === 'abriron' ? 'Abriron' : host
      return v ? name + ' Cloud Panel V ' + v : ''
    },
  },
}
</script>
